import React from "react";

function RightCard({ image, header, description, description01 = null,description02 = null ,description03 = null,description04 = null ,description05 = null}) {
  return (
    <div className="right-card">
      <div className="right-card-desc">
        <h2>{header}</h2>
        <p>{description}</p>
        {description01 && <p>{description01}</p>}
         {description02 && <p>{description02}</p>}
         {description03 && <p>{description03}</p>}
         {description04 && <p>{description04}</p>}
         {description05 && <p>{description05}</p>}
      </div>

      <div className="right-card-image">
        <img src={image} alt={header} />
      </div>
    </div>
  );
}

export default RightCard;
